import { render, staticRenderFns } from "./ShopDetails.vue?vue&type=template&id=1b15cbda&scoped=true"
import script from "./ShopDetails.vue?vue&type=script&lang=js"
export * from "./ShopDetails.vue?vue&type=script&lang=js"
import style0 from "./ShopDetails.vue?vue&type=style&index=0&id=1b15cbda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b15cbda",
  null
  
)

export default component.exports